import { mediaMobileLandscape } from "@/main/services/utilsLayout";
import styled, { css } from "styled-components";

export const Container = styled.div`
	position: relative;
	width: fit-content;
`;

export const ContainerImagePreview = styled.div`
	width: fit-content;
	height: 100%;
	overflow: hidden;

	img {
		width: 100%;
		height: 100%;
		object-fit: contain;

		${mediaMobileLandscape(css`
			max-width: 420px;
			max-height: 230px;
		`)}
	}
`;

interface NameFileProps {
	$backgroundColor?: string;
}
export const NameFile = styled.div<NameFileProps>`
	position: absolute;
	top: 70%;
	left: -8px;
	transform: translateY(-70%);
	font-size: 0.525rem;
	font-weight: bolder;
	border-radius: 2px;
	padding: 2px 3px;
	color: ${({ theme }) => theme.white};
	background-color: ${({ $backgroundColor, theme }) => $backgroundColor ?? theme.grayLight};
`;
